import { GridLegacy as Grid, styled } from '@mui/material'
import { theme, tokens } from 'ComponentLibrary'
import { BaseSyntheticEvent, ReactNode } from 'react'
import FormFooterButtons from 'ComponentLibrary/src/molecules/Form/FormFooter/FormFooterButtons'

type FooterProps = {
    onSubmit?: (event: BaseSyntheticEvent) => void
    onCancel?: () => void
    shouldDisableSubmit?: boolean
    dense?: boolean
    reducedPadding?: boolean
    isPersisting?: boolean
    additionalFooterElement?: ReactNode
}

export default function Footer({
    onSubmit,
    onCancel,
    shouldDisableSubmit,
    dense = false,
    reducedPadding = false,
    isPersisting,
    additionalFooterElement,
}: FooterProps) {
    if (!onSubmit && !onCancel) {
        return null
    }

    return (
        <Grid
            minWidth={'100%'}
            display={'flex'}
            justifyContent={'space-between'}
            alignItems="center"
            paddingTop={dense || reducedPadding ? theme.spacing(5) : theme.spacing(12)}
        >
            {additionalFooterElement}
            <Wrapper>
                <FormFooterButtons
                    onSubmit={onSubmit}
                    onCancel={onCancel}
                    shouldDisableSubmit={shouldDisableSubmit}
                    dense={dense}
                    isPersisting={isPersisting}
                />
            </Wrapper>
        </Grid>
    )
}

const Wrapper = styled('div')({
    justifyContent: 'flex-end',
    display: 'flex',
    gap: tokens.SizingSpacing150,
    width: '100%',
})
